const IMPORT_TRADE = {
  navigationPath: 'wholesale/import-trade',
  routePath: 'import-trade',
}

const PRODUCTION_PLAN_EXPORT = {
  navigationPath: 'wholesale/production-plan-export',
  routePath: 'production-plan-export',
}

const INDEX = IMPORT_TRADE

export const WholesaleLayoutRouteInformation = {
  IMPORT_TRADE,
  PRODUCTION_PLAN_EXPORT,
  INDEX,
} as const
